export class RecipientModel {
  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.short = data.short;
    this.status = data.status;
    if (data.fuelTypes) this.fuelTypes = data.fuelTypes;
    else this.fuelTypes = [];
  }

  id: string;
  name: string;
  short: string;
  fuelTypes: Array<any>;
  status: boolean;
}
